var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-status"},[_c('img',{attrs:{"src":_vm.notFind}})])
}
var staticRenderFns = []

export { render, staticRenderFns }